import styled, { css } from "styled-components";
import type { Property } from "csstype";

import { transition } from "@ui/helpers";

import { RootProps } from "./Image.types";

export const Root = styled.div<RootProps>`
  --image-span: 10px;
  --image-transition: ${props =>
    transition("opacity", props.theme.animations.durationLong)};

  position: relative;
  aspect-ratio: ${props => `${props.$width}/${props.$height}`};
  display: block;
`;

export const Base64 = styled.img<{ $objectFit?: Property.ObjectFit }>`
  position: absolute;
  inset: calc(var(--image-span) * -1);
  width: calc(100% + var(--image-span) * 2);
  height: calc(100% + var(--image-span) * 2);
  transition: var(--image-transition);
  object-fit: ${props => props.$objectFit};
  z-index: 0;
`;

export const Image = styled.img<{
  $objectFit?: Property.ObjectFit;
  $fadeInAnimation?: boolean;
}>`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  transition: var(--image-transition);
  object-fit: ${props => props.$objectFit};
  z-index: 1;

  ${props =>
    props.$fadeInAnimation &&
    css`
      opacity: 0;
    `}
`;
